import React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    size?: number;
};

const RemoveBg03Icon = ({
    color = 'currentColor',
    size = 24,
    strokeWidth = 2,
    strokeLinecap = 'round',
    ...props
}: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            stroke={color}
            strokeLinecap={strokeLinecap}
            strokeWidth={strokeWidth}
            d="M16.2 21H8.93c-.606 0-.908 0-1.049-.12a.5.5 0 0 1-.173-.42c.014-.183.228-.397.657-.826l6.503-7.503c.396-.396.594-.594.822-.668a1 1 0 0 1 .618 0c.228.074.426.272.822.668L21 16m-4.8 5c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.31-1.311C21 18.72 21 17.88 21 16.2V16m-4.8 5H9.8M21 16v-2M3 14v1.5M3 10V8.5M8.362 3H10m-5.5.17c-.629.235-1.095.7-1.33 1.33m0 15c.235.629.7 1.095 1.33 1.33M21 10V8.5M15.637 3H14m5.5.17c.629.235 1.095.7 1.33 1.33M11 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        />
    </svg>
);
export { RemoveBg03Icon };
